<div class="cf-dlg" [class.cp-page]="!isDialog">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>public</mat-icon></div>
    <div class="cp-header-text">
      <h2 class="cf-dlg-title">Portal del cliente</h2>
      <p class="cf-dlg-subtitle" *ngIf="data?.contactName">{{ data.contactName }}</p>
      <p class="cf-dlg-subtitle" *ngIf="!data?.contactName">Un enlace para que el cliente vea y descargue las facturas que le has emitido, sin usuario ni contraseña</p>
    </div>
    <button *ngIf="isDialog" mat-icon-button class="cf-dlg-close" (click)="close()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="loading" message="Cargando el portal del cliente…"></app-loading-state>

  <div class="cf-dlg-body" *ngIf="!loading">
    <!-- Error al cargar -->
    <div class="cp-state cp-state--error" *ngIf="loadError">
      <mat-icon>error_outline</mat-icon>
      <p class="cp-state__title">No se ha podido cargar el portal del cliente</p>
      <button mat-stroked-button class="cf-btn" (click)="load()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>

    <!-- Portal apagado -->
    <div class="cp-state" *ngIf="!loadError && !enabled">
      <mat-icon>lock</mat-icon>
      <p class="cp-state__title">El portal del cliente está desactivado</p>
      <p class="cp-state__sub">
        Actívalo para poder dar a tus clientes un enlace donde consultar sus facturas, ver cuáles tienen pendientes
        y descargar el PDF. Se activa para toda tu cuenta; cada cliente tendrá su propio enlace.
      </p>
      <button mat-flat-button class="cf-btn cf-btn--primary" (click)="enablePortal()" [disabled]="working">
        <mat-icon>check_circle</mat-icon> Activar el portal del cliente
      </button>
    </div>

    <!-- Activo, sin enlace -->
    <div class="cp-state" *ngIf="!loadError && enabled && !link">
      <mat-icon>link</mat-icon>
      <p class="cp-state__title">Este cliente todavía no tiene enlace</p>
      <p class="cp-state__sub">Crea el enlace y envíaselo. Quien lo tenga podrá ver las facturas emitidas a este cliente.</p>
      <button mat-flat-button class="cf-btn cf-btn--primary" (click)="createLink()" [disabled]="working">
        <mat-icon>link</mat-icon> Crear enlace
      </button>
    </div>

    <!-- Activo, con enlace -->
    <ng-container *ngIf="!loadError && enabled && link">
      <div class="cp-section__label">Enlace del cliente</div>

      <div class="cp-link">
        <input class="cp-link__input" type="text" [value]="url" readonly (focus)="$any($event.target).select()"
               aria-label="Enlace del portal del cliente" />
        <button mat-flat-button class="cf-btn cf-btn--primary" (click)="copyLink()">
          <mat-icon>content_copy</mat-icon> Copiar
        </button>
        <button mat-stroked-button class="cf-btn" (click)="openLink()">
          <mat-icon>open_in_new</mat-icon> Abrir
        </button>
      </div>

      <p class="cp-warning" *ngIf="link.isExpired">
        <mat-icon>warning</mat-icon>
        Este enlace caducó el {{ link.expiresAt | date:'dd/MM/yyyy' }}. Regenéralo para dar uno nuevo al cliente.
      </p>

      <dl class="cp-facts">
        <div>
          <dt>Creado</dt>
          <dd>{{ link.createdAt | date:'dd/MM/yyyy HH:mm' }}</dd>
        </div>
        <div>
          <dt>Último acceso</dt>
          <dd>{{ link.lastAccessAt ? (link.lastAccessAt | date:'dd/MM/yyyy HH:mm') : 'Todavía no lo ha abierto' }}</dd>
        </div>
        <div>
          <dt>Accesos</dt>
          <dd>{{ link.accessCount }}</dd>
        </div>
        <div *ngIf="link.expiresAt && !link.isExpired">
          <dt>Caduca</dt>
          <dd>{{ link.expiresAt | date:'dd/MM/yyyy' }}</dd>
        </div>
      </dl>

      <p class="cp-hint">
        <mat-icon>schedule</mat-icon>
        Es un enlace privado: no lo publiques. Si crees que lo tiene quien no debe, regenéralo o revócalo.
      </p>

      <div class="cp-actions">
        <button mat-stroked-button class="cf-btn" (click)="regenerateLink()">
          <mat-icon>refresh</mat-icon> Regenerar enlace
        </button>
        <button mat-stroked-button class="cf-btn cp-btn-danger" (click)="revokeLink()">
          <mat-icon>block</mat-icon> Revocar enlace
        </button>
      </div>
    </ng-container>

    <div class="cp-footer" *ngIf="!loadError && enabled">
      <span>El portal del cliente está activado para toda tu cuenta.</span>
      <button mat-button class="cp-footer__btn" (click)="disablePortal()">Desactivar el portal</button>
    </div>
  </div>
</div>
